export const STEPS = {
  INPUT_DOMAIN: 'inputDomain',
  EXTERNAL_DOMAIN: 'external',
  SUCCESS: 'success',
  EXTERNAL_SUCCESS: 'external_success',
  DOMAIN_NOT_REGISTERED: 'not_registered',
  LOADING: 'loading',
  NOT_REGISTERED_SUCCESS: 'domain_not_registered_success',
};
